import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import i18n from 'i18next';
import 'react-perfect-scrollbar/dist/css/styles.css';
import PerfectScrollbar from 'react-perfect-scrollbar';

import ACTIONS from '../../actions/lexon';
import { getProducts } from '../../services/minihub';
import { Popover, PopoverBody } from 'reactstrap';

class MenuMinihub extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dropdownOpen: false,
      products: []
    };
  }

  componentDidMount() {
    const { lexon } = this.props;
    const _this = this;
    if (lexon.userId) {
      getProducts(lexon.userId, lexon.lexonToken)
        .then(result => {
          if (result.errors.length === 0) {
            _this.setState({
              products: result.data.filter(product => product.indAcceso !== '1')
            });
          } else {
            let errors;
            result.errors.forEach(error => {
              errors = `${error} `;
            });
            console.error('error ->', errors);
          }
        })
        .catch(error => {
          console.error('error ->', error);
        });
    }
  }

  render() {
    const { dropdownOpen, products } = this.state;

    return (
      <Fragment>
        <div
          className={`menu-minihub ml-3 mr-4`}
          id="menu-minihub-popover"
          onClick={() => {
            this.setState({
              dropdownOpen: !dropdownOpen
            });
          }}
        >
          <img src="/assets/icons/header/mini-hub.svg" alt="mini-hub" />
        </div>
        <Popover
          trigger="legacy"
          isOpen={dropdownOpen}
          target="menu-minihub-popover"
          toggle={() => {
            this.setState({ dropdownOpen: false });
          }}
          placement="bottom"
          className="popover-menu-minihub"
        >
          <PopoverBody>
            <div className="popover-minihub-container">
              <div>
                <span className="text-color-blue-lefebvre inter-bold-18">
                  {i18n.t('menu-minihub.products')}
                </span>
                <div className="products-divider" />
              </div>
              <PerfectScrollbar options={{ suppressScrollX: true }}>
                <ul className="minihub-products-container pt-2">
                  {products.map(product => (
                    <li
                      key={product.url}
                      className="mb-2"
                      onClick={() => {
                        window.open(product.url, '_blank');
                      }}
                    >
                      <div className="minihub-product-item">
                        <i className={`${product.icono} product-icon`}></i>
                        <span className="inter-regular-16 ml-2 text-color-grey-800">
                          {product.descHerramienta}
                        </span>
                      </div>
                    </li>
                  ))}
                </ul>
              </PerfectScrollbar>
            </div>
          </PopoverBody>
        </Popover>
      </Fragment>
    );
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators({ setSign: ACTIONS.setSign }, dispatch);

const mapStateToProps = state => ({
  lexon: state.lexon
});

export default connect(mapStateToProps, mapDispatchToProps)(MenuMinihub);
